var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form tab-content" },
    [
      _c("input-field", {
        attrs: {
          value: _vm.getValueInObject("tp_pe_angle"),
          label: _vm.$t("Angle") + " (grads)",
          size: "medium",
          inputType: "number",
          step: 0.01,
          max: 400,
          fieldDisabled: _vm.readOnly
        },
        on: {
          input: function($event) {
            return _vm.updateValue("tp_pe_angle", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46ac1d7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ac1d7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/PoleEffortModule/AngleTab.vue
// module id = null
// module chunks = 